ready(() => {

    const header = document.querySelector(".header");
    if (header) {
        const headerInner = header.querySelector(".header__inner"),
            burger = header.querySelector(".header__burger"),
            search = header.querySelector(".header__search"),
            searchInput = search.querySelector(".header__search .form-text"),
            searchBtn = header.querySelector(".header__search-btn"),
            catalogBtn = header.querySelector(".header__menu-catalog .btn-catalog");

        burger.addEventListener("click", e => {
            header.classList.toggle("is-open-menu-main");
            if (document.body.offsetWidth <= 1023) {
                headerInner.append(createElement("div", ["header__close"]));
                // $('body').pageScrollHide();
            }
            const headerClose = document.querySelector(".header__close");
            headerClose.addEventListener("click", e => {
                header.classList.remove("is-open");
                headerClose.remove();
                // $('body').pageScrollShow();
            });
        });

        searchBtn.addEventListener("click", e => {
            header.classList.toggle("is-open-search");
        });

        catalogBtn.addEventListener("click", e => {
            e.currentTarget.parentElement.parentElement.classList.toggle("is-open");
        });

        document.addEventListener("click", e => {
            if (e.target === burger || e.target === searchBtn || e.target === searchInput) {
                e.target;
                console.log("e.target", e.target);
            } else {
                header.classList.remove("is-open-menu-main");
                header.classList.remove("is-open-search");

                const headerClose = header.querySelector(".header__close");
                headerClose && headerClose.remove();
            }
            e.target === burger ? header.classList.remove("is-open-search") : e.target;
            e.target === catalogBtn ? e.target : catalogBtn.parentElement.parentElement.classList.remove("is-open");
        });

        header.querySelectorAll(".list-level-0 li").forEach((li) => {
            if (li.getAttribute("data-ico")) {
                li.querySelector("a").prepend(createElement("img", "", {
                    src: li.getAttribute("data-ico"),
                    alt: "",
                }));
            }
        });
    }
});





// // eslint-disable-next-line no-undef
// ready(() => {
//     const header = document.querySelector(".header"),
//           headerContainer = header.querySelector(".header__inner"),
//           headerBurger = header.querySelector(".header__burger"),
//           headerCatalogBtn = header.querySelector(".header__menu-catalog .btn-catalog");
//     headerBurger.addEventListener("click", e => {
//         header.classList.toggle("is-open");
//         console.log(headerBurger.classList.contains('is-open'))
//
//         headerBurger.classList.toggle("is-open");
//         if (headerBurger.classList.contains('is-open')) {
//             // $('body').pageScrollHide();
//         } else  {
//             // $('body').pageScrollShow();
//         }
//
//         // const headerClose = document.querySelector(".header__close");
//         // headerClose.addEventListener("click", e => {
//         //     header.classList.remove("is-open");
//         //     headerClose.remove();
//         //     $('body').pageScrollShow();
//         // });
//     });
//     const searchBtn = document.querySelector(".header__search-btn");
//     searchBtn.addEventListener("click", evt => {
//         searchBtn.classList.toggle("is-open");
//         headerBurger.classList.remove('is-open');
//     })
//     headerCatalogBtn.addEventListener("click", e => {
//         e.currentTarget.parentElement.parentElement.classList.toggle("is-open");
//     });
//
//     document.addEventListener('click', e => {
//         if (document.body.offsetWidth <= 767) {
//             e.target === headerBurger ? e.target : header.classList.remove("is-open");
//             // $('body').pageScrollShow();
//         } else if (document.body.offsetWidth >= 1024) {
//             // e.preventDefault();
//             // e.target === headerCatalogBtn ? e.target : headerCatalogBtn.parentElement.parentElement.classList.remove("is-open");
//             // console.log(e.target)
//             // console.log(headerCatalogBtn)
//             // $('body').pageScrollShow();
//         }
//     });
// });